var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import { APP_LINK_PAGE_NAME_WITH_ROUTE, EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { ELSCommonUIConstants } from 'components/common';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { FeatureFlagNames } from 'constants/app.constant';
import { isEnabledMockService } from 'helpers/app.helper';
import { shouldRenderAssignmentDetailAppLinkUrl, renderAppLinkingAssignmentName } from 'services/app-linking.service';
import { ASSIGNMENT_TYPES, VALUE_NA, VALUE_NA_TEXT } from 'reports/cw/constants/report.constant';
import { ASSIGNMENT_SCORING_TYPE_MAPPING } from 'reports/cw/models';
import { asTimestringFormated } from 'reports/cw/services/report.service';
import { getInteractiveReviewBody } from 'reports/cw/helpers/student-assignment.helper';
import { isNotGradeAssignment } from 'reports/cw/helpers/report.helper';
var dateFormat = ELSCommonUIConstants.momentDateFormat.datePrimary;
export var compareDate = function (r1, s2) { return moment(r1.dueDate).diff(moment(s2.dueDate)); };
export var getBody = function (_a) {
    var assignmentId = _a.assignmentId, searchKeyword = _a.searchKeyword, assignmentTypeId = _a.assignmentTypeId, xLinkId = _a.xLinkId, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, assignmentType = _a.assignmentType, courseSectionInfo = _a.courseSectionInfo, catalog = _a.catalog, assignments = _a.assignments, isEnabledAMAAssignment = _a.isEnabledAMAAssignment;
    var targetPage = isEnabledAMAAssignment ? APP_LINK_PAGE_NAME_WITH_ROUTE.ASSIGNMENT_DETAIL_REPORT.name : '';
    var body = {
        performanceReportPage: APP_LINK_PAGE_NAME_WITH_ROUTE.CW_ASSIGNMENT_ENGAGEMENT.name,
        keptXLinkId: xLinkId,
        keptIsBackToPreviousAppIconShown: {
            isKept: true,
            value: isBackToPreviousAppIconShown
        },
        keptFilterData: [
            {
                actionName: 'setCWAssignmentEngagementTableSearch',
                value: searchKeyword
            },
            {
                actionName: 'setCWEngagementAssignmentTypeDropdownId',
                value: assignmentTypeId
            }
        ],
        targetPage: targetPage
    };
    if (assignmentType === ASSIGNMENT_TYPES.INTERACTIVE_REVIEW.id) {
        body = __assign(__assign({}, body), getInteractiveReviewBody(courseSectionInfo, catalog, assignments, assignmentId));
    }
    if (assignmentType === ASSIGNMENT_TYPES.SLS_PRE_SIMULATION_QUIZ.id ||
        assignmentType === ASSIGNMENT_TYPES.SLS_POST_SIMULATION_QUIZ.id ||
        assignmentType === ASSIGNMENT_TYPES.SLS_SIMCHART_SIMULATION_EHR.id ||
        assignmentType === ASSIGNMENT_TYPES.SLS_JOURNALING_EXERCISE.id) {
        return __assign(__assign({}, body), { targetPage: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.APP_NAME });
    }
    return body;
};
export var renderName = function (_a) {
    var row = _a.row, featureFlags = _a.featureFlags, courseId = _a.courseId, xLinkId = _a.xLinkId, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, searchKeyword = _a.searchKeyword, assignmentTypeId = _a.assignmentTypeId, onRedirectToOutsideApp = _a.onRedirectToOutsideApp, courseSectionInfo = _a.courseSectionInfo, catalog = _a.catalog, assignments = _a.assignments;
    var id = row.id, name = row.name, assignmentType = row.assignmentType;
    if (shouldRenderAssignmentDetailAppLinkUrl(row.assignmentType, featureFlags, courseId) && !isEnabledMockService()) {
        var isEnabledAMAAssignment = isFeatureEnabled(featureFlags, FeatureFlagNames.ENABLE_AMA_ASSIGNMENT_DETAIL);
        var assignmentConfig = {
            id: id.toString(),
            name: name,
            type: assignmentType,
            isEnabledAMAAssignment: isEnabledAMAAssignment
        };
        var body = getBody({
            searchKeyword: searchKeyword,
            assignmentTypeId: assignmentTypeId,
            xLinkId: xLinkId,
            isBackToPreviousAppIconShown: isBackToPreviousAppIconShown,
            assignmentType: assignmentType,
            assignmentId: id,
            courseSectionInfo: courseSectionInfo,
            catalog: catalog,
            assignments: assignments,
            isEnabledAMAAssignment: isEnabledAMAAssignment
        });
        var renderAppLinkingAssignmentNameProps = {
            assignmentConfig: assignmentConfig,
            assignmentType: assignmentType,
            body: body,
            handleRedirectToOutsideApp: onRedirectToOutsideApp
        };
        return (<div title={name} className="c-cw-assignment-engagement-detail-table__cell-assignment-name">
        {renderAppLinkingAssignmentName(renderAppLinkingAssignmentNameProps)}
      </div>);
    }
    return (<div title={name} className="c-cw-assignment-engagement-detail-table__cell-assignment-name">
      <span>{name}</span>
    </div>);
};
export var renderDueDate = function (row) {
    var dueDate = row.dueDate, scoringType = row.scoringType;
    if (isNotGradeAssignment(scoringType) && !dueDate) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    if (!dueDate) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    return <span>{moment(dueDate).format(dateFormat)}</span>;
};
export var renderScoringType = function (row) {
    return <span>{(ASSIGNMENT_SCORING_TYPE_MAPPING === null || ASSIGNMENT_SCORING_TYPE_MAPPING === void 0 ? void 0 : ASSIGNMENT_SCORING_TYPE_MAPPING[row.scoringType]) || row.scoringType}</span>;
};
export var renderClassAvgGrade = function (row) {
    var percentCompletion = row.percentCompletion, scoringType = row.scoringType, classAvgScore = row.classAvgScore;
    if (percentCompletion === 1 && isNotGradeAssignment(scoringType)) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    if (!classAvgScore) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    return <span>{"".concat(+(classAvgScore * 100).toFixed(0), "%")}</span>;
};
export var renderClassAvgTimeSpent = function (row) {
    var classAvgTimeSpentSeconds = row.classAvgTimeSpentSeconds;
    if (classAvgTimeSpentSeconds === 0) {
        return <span>{VALUE_NA}</span>;
    }
    return <span>{asTimestringFormated(+classAvgTimeSpentSeconds.toFixed(0))}</span>;
};
export var renderPercentCompletion = function (row) {
    return <span>{"".concat(+(row.percentCompletion * 100).toFixed(0), "%")}</span>;
};
